module.exports = __webpack_public_path__ + "static/media/dcnc.0d588eec.png";